var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vr"},[_c('iframe',{staticClass:"pre-bg-img2",attrs:{"width":"100vw","height":"100vh","src":_vm.iframeSrc}}),_c('MyNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }